module.exports = __webpack_public_path__ + "img/9788997924363.25e4c4a5.jpg";